import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { LessonCard } from '../../shared';
import { useLesson } from '../../../context/LessonContext';
import { useCourse } from '../../../context/CourseContext';
import { PopupModel, AddReviewRating, AlertMassage } from '../../shared';
import { useLogin } from '../../../context/LoginContext'

const LessonsList = () => {
    const {user} = useLogin()
    const [showAlert, setShowAlert] = useState({
        type: '',
        title: '',
        msg: ``,
        show: false
    });
    const { courseDetail, lessons } = useLesson();
    const { HandelAddreviewRatting, addreviewRatting,saveReviewRating } = useCourse();
    const [isAllvideoCompleted, setIsAllVideoCompleted] = useState(false);
    useEffect(() => {
        if (lessons?.length > 0) {
            const videoLessons = lessons.filter(lesson => lesson.type === 'video');
            const allCompleted = videoLessons.every(lesson => lesson.status === 'completed');
            setIsAllVideoCompleted(allCompleted);
        }
    }, [lessons]);

    useEffect(() => {
        const hasRating = courseDetail?.ratingdata?.rating || 0;
        if (user?.selectedRole === 'viewer' && lessons?.length > 0 && !hasRating) {
            const allLessonsCompleted = lessons.every(lesson => lesson.status === 'completed');
            allLessonsCompleted && HandelAddreviewRatting(true, courseDetail.title, courseDetail.courseRatingSummary, courseDetail._id, '');
        }
    }, [lessons,courseDetail,user]);

    const handlelSaveRating = async (rating, review) => {
        try {
            const courseId = addreviewRatting?.courseId || addreviewRatting?.courseID || addreviewRatting?.course_id || courseDetail?._id;
            const rawResponse = await saveReviewRating( rating, courseId, review);
            const saveresponse = rawResponse?.data ?? rawResponse;
            // console.log("🚀 krishna  ~ saveresponse:", saveresponse);
            setShowAlert({
                type: saveresponse?.success ? 'success' : 'danger',
                title: saveresponse?.success ? 'Success' : 'Error',
                msg: saveresponse?.success ? `Your review and rating is submitted successfully` : saveresponse?.message || `Failed to submit your review and rating`,
                show: true
            });
        } catch (error) {
            // console.error("Error saving review:", error);
            setShowAlert({
                type: 'danger',
                title: 'Error',
                msg: error?.message || 'Failed to submit your review and rating',
                show: true
            });
        }
    }
    const hideAlert = () => {
        setShowAlert({
            type: '',
            title: '',
            msg: '',
            show: false
        })
    }
    return (
        <Row>
            <Col md={12}>
                <div className='course-infohead-section'>
                    <small className="list-selected-badge badge bg-primary">Course Title</small>
                    <h5 style={{ fontWeight: '800' }}>{courseDetail.title}</h5>
                    <small className="d-block">{`Video : ${courseDetail?.videoLength} | Duration: ${courseDetail?.courseDuration}`}</small>
                    <small className="d-block pb-3">{`Assessment : ${courseDetail?.assessmentLength}`}</small>
                </div>
            </Col>
            {lessons?.length > 0 && (
                lessons.map((lesson, idx) => {
                    return (
                        <LessonCard
                            key={lesson.refId || idx}
                            lesson={lesson}
                            idx={idx}
                            isDisabled={lesson.type === 'quiz' && !isAllvideoCompleted}
                        />
                    )
                })
            )}
            {addreviewRatting.status &&
                <PopupModel
                    size='md'
                    showModal={addreviewRatting.status}
                    handleCloseModal={HandelAddreviewRatting.bind(this, false, '', 0, '')}
                    title={`Review & Rating`}
                    type={'info'}
                >
                    <AddReviewRating courseTitle={addreviewRatting.coursetitle} onHandelSave={handlelSaveRating} ratingValue={addreviewRatting.rating} reviewValue='' />
                </PopupModel>
            }
            {showAlert.show &&
                <AlertMassage
                    show={showAlert.show}
                    type={showAlert.type}
                    title={showAlert.title}
                    massage={showAlert.msg}
                    hideAlert={hideAlert} />
            }
        </Row>
    );
};

export default LessonsList;